// Vista categorías
import React from 'react';
import API from '../../configAPI';
import {Link} from 'react-router-dom';
import PulseLoader from 'react-spinners/PulseLoader';
import CONFIG from '../../config';
import BannerLarge from '../partials/BannerLarge';
class CategoriesItem extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            item_slug : this.props.match.params.item,
            item : {
              categories : []
            },
            loading: true
        }
    }

    componentDidMount(){
       API.PRODUCTS(`categories/item/${this.state.item_slug}`)
       .then(resp =>{
           window.scrollTo(0, 0);
           this.setState({
               item: resp.data,
               loading: false
           });
       })
       .catch(err =>{
           console.log(err);
       });
    }

    render(){
        return (
            <div className="container-fluid mt-2 mb-2">

                {/* <BannerLarge 
                    url="https://dossierdearquitectura.com/"
                    image="https://dossierdearquitectura.com/banner/da728x160.jpg"
                    title="Visite Dossier de Arquitectura"
                /> */}


                <div className="col-12">
                    <PulseLoader
                        css={CONFIG.spinner_css}
                        size={CONFIG.spinner_size}
                        margin={CONFIG.spinner_margin}
                        color={CONFIG.spinner_color}
                        loading={this.state.loading}
                    />
                    <div className="row d-flex flex-wrap mt-2">
                        {/* <div className="col-xs-12 col-md-3 mt-1 mb-1">
                            <div className="list-group">
                                <li className="list-group-item secondary bg-black">{this.state.item.name}</li>
                                {this.state.item.categories.map((categ,index) =>(
                                    <Link to={`/productos/${this.state.item.slug}/${categ.slug}`} key={index} className="list-group-item d-flex justify-content-between align-items-center list-group-item-action item-menu">
                                        {categ.name}
                                    </Link>
                                ))}
                            </div>
                        </div> */}
                        <div className="col-xs-12 col-md-12 mt-1 mb-1">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item" aria-current="page">
                                        <Link to={'/productos'}>Todas las categorías</Link>
                                    </li>
                                    <li className="breadcrumb-item" aria-current="page">{this.state.item.name}
                                    </li>
                                </ol>
                            </nav>
                            <div className="row d-flex flex-wrap mt-1">
                            {this.state.item.categories.map((categ,index) =>(
                                <article className="col-6 col-sm-6 col-md-3 mt-2" key={index}>
                                    <div className="rubro">
                                        <Link to={`/productos/${this.state.item.slug}/${categ.slug}`}>
                                                <img src={categ.url_image} alt={categ.name}/>
                                                <h3>{categ.name}</h3>
                                        </Link>
                                        <ul>
                                            {categ.sub_categories.map((subcate,index2)=>(
                                                (index2 < 5 ?
                                                    <li key={index2}><Link to={`/productos/${this.state.item.slug}/${categ.slug}/${subcate.slug}`}>{subcate.name}</Link></li>
                                                    : ''
                                                )
                                            ))}
                                            <li><Link to={`/productos/${this.state.item.slug}/${categ.slug}`} className="link">Ver más</Link></li>
                                        </ul>
                                    </div>
                                </article>
                            ))}
                            </div>
                        </div>
                    </div>
                </div>

                <BannerLarge 
                    url="https://dossierdearquitectura.com/"
                    image="https://dossierdearquitectura.com/banner/da728x160.jpg"
                    title="Visite Dossier de Arquitectura"
                />


            </div>
        )
    }
}
export default CategoriesItem;